import React, { Component } from 'react';
import { HashLink as Link } from 'react-router-hash-link';
import { Helmet } from 'react-helmet';
import { Redirect, withRouter } from 'react-router-dom';
import Moment from 'react-moment';
import { loadStripe } from '@stripe/stripe-js';
import api from '../utils/api';
import TrelloClient from 'react-trello-client';

const stripePromise = loadStripe(process.env.STRIPE_API_KEY);
const prices = {
    basic: process.env.STRIPE_PRICE_BASIC,
    pro: process.env.STRIPE_PRICE_PRO,
};

class Account extends Component {
    constructor(props) {
        super(props);

        this.state = {
            plan: prices.basic,
            delete: false,
            error: '',
            password: '',
            apiSubmitError: '',
        };
    }

    componentDidMount() {
        this._refreshUser();

        //refreshing subscription and then user to be sure that status is correct
        this._refreshSubscription();

        //get user's API keys
        this._getIntegrations();
    }

    render() {
        if (!this.props.user && !this.state.delete) return <Redirect to="/auth/sign-in" />;

        const user = this.props.user;

        let isTrelloApiProvided;
        let isShortcutApiProvided;

        if (this.state.integrations) {
            isTrelloApiProvided = this.state.integrations.find((el) => el.integrationName === 'trello');
            isShortcutApiProvided = this.state.integrations.find(
                (el) => el.integrationName === 'shortcut'
            );
        }

        return (
            <main className="account-container container">
                <Helmet>
                    <meta name="robots" content="noindex" />
                    <title>Account Settings | epicmatic</title>
                </Helmet>
                <div className="title">Account Settings</div>
                <div>
                    <div className="header">Personal details</div>
                    <div>
                        <b>Name and surname: </b>
                        <span style={{ textTransform: 'capitalize' }}>
                            {user.name} {user.surname}
                        </span>
                    </div>
                    <div>
                        <b>Email: </b>
                        <span style={{ textTransform: 'lowercase' }}>{user.email}</span>
                    </div>
                </div>

                <div>
                    <div className="header">Available token credit</div>
                    <div className="credits-wrapper">
                        <b style={{ fontSize: '25px' }}>{user.usageLimit} </b>
                        <div className="underline"></div>
                    </div>
                </div>

                <div className="api-key-form">
                    <div className="header" style={{ marginBottom: '3px' }}>
                        API Keys
                    </div>

                    <div>To integrate external applications, please provide your API keys below.</div>

                    <div className="api-key-title">Trello</div>
                    {this.state.integrations ? (
                        <div className="api-key-wrapper">
                            <input
                                type="text"
                                placeholder={
                                    isTrelloApiProvided
                                        ? `${isTrelloApiProvided.integrationKey.slice(0, 5)}••••••••••`
                                        : 'Trello API key'
                                }
                                value={this.state.trelloApiKey}
                                onChange={(e) => this._handleTrelloApiKeyChange(e.target.value)}
                                required
                            />
                            <div
                                className={isTrelloApiProvided ? 'api-key-added' : 'api-key-missing'}
                            ></div>

                            <button
                                className="payment-btn resign-btn"
                                onClick={this._handleTrelloApiKeySubmit}
                            >
                                {this.state.integrations.find((el) => el.integrationName === 'trello')
                                    ? 'change'
                                    : 'submit'}
                            </button>
                        </div>
                    ) : null}

                    <div className="api-key-title">Shortcut</div>
                    {this.state.integrations ? (
                        <div className="api-key-wrapper">
                            <input
                                type="text"
                                placeholder={
                                    isShortcutApiProvided
                                        ? `${isShortcutApiProvided.integrationKey.slice(0, 5)}••••••••••`
                                        : 'Shortcut API key'
                                }
                                value={this.state.shortcutApiKey}
                                onChange={(e) => this._handleShortcutApiKeyChange(e.target.value)}
                                required
                            />
                            <div
                                className={isShortcutApiProvided ? 'api-key-added' : 'api-key-missing'}
                            ></div>

                            <button
                                className="payment-btn resign-btn"
                                onClick={this._handleShortcutApiKeySubmit}
                            >
                                {isShortcutApiProvided ? 'change' : 'submit'}
                            </button>
                        </div>
                    ) : null}
                </div>
                <div className="delete-error">{this.state.apiSubmitError}</div>

                <div>
                    <div className="header" style={{ marginBottom: '3px' }}>
                        Payments
                    </div>
                    <div>
                        <div className="sub-status">
                            {user.isSubscribed &&
                            user.isComplete &&
                            !user.subscription.cancel_at_period_end
                                ? 'You are currently subscribed.'
                                : null}
                            {!user.isSubscribed && !user.subscription
                                ? 'You are currently unsubscribed and using a free token credit allowance.'
                                : null}

                            {!user.isSubscribed &&
                            user.subscription &&
                            user.subscription.status === 'canceled' ? (
                                <div>
                                    You are currently unsubscribed.
                                    <br />
                                    To reactivate your subscription click the "manage your subscription"
                                    button below.
                                </div>
                            ) : null}
                            {user.isComplete &&
                            user.subscription.cancel_at_period_end &&
                            user.subscription.status === 'active' ? (
                                <span>
                                    Your subscription has been cancelled and will expire on{' '}
                                    <Moment format="DD MMMM YYYY">
                                        {user.subscription.current_period_end * 1000}
                                    </Moment>
                                    .<br />
                                    To reactivate your subscription click the "manage your subscription"
                                    button below.
                                </span>
                            ) : null}
                        </div>
                    </div>
                    {user.isSubscribed && !user.subscription.cancel_at_period_end ? (
                        <div style={{ marginTop: '5px' }}>
                            <div>
                                <b>Payment:</b> {this.state.plan === prices.basic ? '10.00' : '24.99'}€
                            </div>
                            <div className="info-small">
                                The above amount will be charged on{' '}
                                <b>
                                    <Moment format="DD MMMM YYYY">
                                        {user.subscription.subscriptionEndDate}
                                    </Moment>
                                </b>
                                .
                            </div>
                        </div>
                    ) : null}
                </div>

                <div className="btns">
                    {!this.props.user.isComplete ? null : (
                        <button
                            className="payment-btn resign-btn manage-btn"
                            onClick={this._handleSubscriptionClick}
                            style={{ maxWidth: '220px' }}
                        >
                            manage your subscription
                        </button>
                    )}

                    {!this.props.user.isSubscribed && !this.props.user.isComplete ? (
                        <div className="cards">
                            <div className="price-card">
                                <div className="plan">Basic</div>
                                <div className="price">9.90</div>
                                <div>€/month</div>
                                <div className="plan-details">(20 000 token credits each month)</div>
                                <button
                                    className="add-payment"
                                    value={prices.basic}
                                    onClick={(e) => this._completePayment(e.target.value)}
                                >
                                    upgrade
                                </button>
                            </div>
                            <div className="price-card">
                                <div className="plan">Pro</div>
                                <div className="price">24.90</div>
                                <div>€/month</div>
                                <div className="plan-details">(100 000 token credits each month)</div>
                                <button
                                    className="add-payment"
                                    value={prices.pro}
                                    onClick={(e) => this._completePayment(e.target.value)}
                                >
                                    upgrade
                                </button>
                            </div>
                        </div>
                    ) : null}

                    {!this.state.delete ? (
                        <button
                            className="payment-btn resign-btn"
                            onClick={this._handleDeleteClick}
                            style={{ maxWidth: '220px' }}
                        >
                            delete account
                        </button>
                    ) : null}
                </div>

                {this.state.delete ? (
                    <div className="delete-wrapper">
                        <div>
                            If you are sure you want to delete your account, please enter your password
                            below and confirm your choice.
                        </div>
                        <input
                            className="safari-input-btn"
                            type="password"
                            placeholder="password"
                            value={this.state.password}
                            onChange={(e) => this._handleInputChange(e.target.value)}
                            required
                        />
                        <button className="payment-btn resign-btn" onClick={this._cancelSubscription}>
                            delete
                        </button>
                        <div className="delete-error">{this.state.error}</div>
                    </div>
                ) : null}

                <div>
                    <div className="header" style={{ marginBottom: '3px', paddingTop: '20px' }}>
                        FAQ
                    </div>
                    <div className="acc-faq-container">
                        <div className="acc-faq-wrapper">
                            <div className="faq-question">
                                Do I get new free token credits each month?
                            </div>
                            <div>No. The initial token credit allowance (2 500) is not renewable.</div>
                        </div>
                        <div className="acc-faq-wrapper">
                            <div className="faq-question">
                                Do my token credits accumulate from month to month?
                            </div>
                            <div>
                                No, if you are a paid subscriber, you get a new token credit allowance
                                each month (20 000 in the BASIC plan and 100 000 in the PRO plan).
                            </div>
                        </div>
                        <div className="acc-faq-wrapper">
                            <div className="faq-question">When can I cancel my subscription?</div>
                            <div>
                                You can cancel your subscription anytime. After cancellation, your
                                subscription won't renew in the new billing period.{' '}
                                <b>We don't offer any refunds for cancelled subscriptions.</b>
                            </div>
                        </div>
                        <div className="acc-faq-wrapper">
                            <div className="faq-question">What happens if I unsubscribe?</div>
                            <div>
                                Your subscription will be cancelled at the end of the billing period.{' '}
                                <b>You can reactivate your account at any time.</b>
                            </div>
                        </div>
                        <div className="acc-faq-wrapper">
                            <div className="faq-question">What happens if I delete my account?</div>
                            <div>
                                Your subscription will be cancelled, all user data will be removed
                                immediately. <b>Deletion of the account cannot be reverted.</b>
                            </div>
                        </div>
                        <div className="acc-faq-wrapper">
                            <div className="faq-question">Where can I find my invoice?</div>
                            <div>
                                To download your invoice, click on the{' '}
                                <b>manage your subscription button</b> above. All your invoices are
                                available in the INVOICE HISTORY section.
                            </div>
                        </div>
                    </div>
                    <div style={{ marginTop: '30px' }}>
                        Answers to other FAQs can be found{' '}
                        <Link className="link faq-link" to="/faq">
                            here.
                        </Link>
                    </div>
                </div>
            </main>
        );
    }

    _completePayment = (plan) => {
        api.post('/api/payment/create-checkout-session', { plan })
            .then((data) => {
                let sessionId = data.session;
                this._handleStripeCheckout(sessionId);
            })
            .catch((err) => {
                this.setState({ error: err.description });
            });
    };

    _handleStripeCheckout = (sessionId) => {
        stripePromise.then((stripe) => {
            stripe.redirectToCheckout({
                sessionId: sessionId,
            });
        });
    };

    _cancelSubscription = () => {
        if (this.props.user.stripeCustomerId) {
            api.post('/api/payment/unsubscribe')
                .then((data) => {
                    this._deleteAccount();
                })
                .catch((err) => {
                    this.setState({
                        error: err.description,
                    });
                });
        } else {
            this._deleteAccount();
        }
    };

    _deleteAccount = () => {
        this.setState({
            error: '',
        });

        let password;

        if (this.state.password) {
            password = { password: this.state.password };

            api.post('/api/auth/delete', password)
                .then((data) => {
                    this.props.history.push('/account-deleted');

                    localStorage.removeItem('identity');
                    this.props.resetUser();
                })
                .catch((err) => {
                    this.setState({
                        error: err.description,
                    });
                });
        } else {
            this.setState({
                error: 'Please provide your password.',
            });
        }
    };

    _handleInputChange = (newValue) => {
        this.setState({
            password: newValue,
        });
    };

    _handleDeleteClick = () => {
        let currentDelete = this.state.delete;

        this.setState({
            error: '',
            unsubscribe: !currentDelete ? false : true,
            delete: !this.state.delete,
        });
    };

    _handleSubscriptionClick = () => {
        api.post('/api/payment/customer-portal')
            .then((data) => {
                const redirect = window.open(data.portal_url, '_self');
                if (redirect) redirect.opener = null;
            })
            .catch((err) => {
                this.setState({
                    error: err.description,
                });
            });
    };

    _refreshUser = () => {
        api.post('/api/auth/refresh')
            .then((data) => {
                localStorage.setItem('identity', data.token);
                this.props.setUser();
            })
            .catch((err) => {
                this.setState({
                    error: err.description,
                });
            });
    };

    _refreshSubscription = () => {
        api.post('/api/payment/refresh-subscription').then((data) => {
            this.setState({
                plan: data.subscription ? data.subscription.plan : prices.basic,
            });
            this._refreshUser();
        });
    };

    _getIntegrations = () => {
        //fetch api keys for user
        api.get('/api/integration/get-api-keys').then((data) => {
            const response = data.integrations;

            this.setState({
                integrations: response,
            });
        });
    };

    _handleTrelloApiKeyChange = (newValue) => {
        // new value should be set to state
        this.setState({
            trelloApiKey: newValue,
        });
    };

    _handleTrelloApiKeySubmit = () => {
        if (!this.state.trelloApiKey || !this.state.trelloApiKey.replace(/\s/g, '').length) {
            this.setState({
                apiSubmitError: 'Please provide a valid API key.',
            });
        } else {
            api.post('/api/integration/set-api-key', { name: 'trello', key: this.state.trelloApiKey })
                .then((data) => {
                    this._refreshUser();
                    this._getIntegrations();

                    this.setState({
                        trelloApiKey: '',
                        apiSubmitError: '',
                    });
                })
                .catch((err) => {
                    this.setState({
                        error: err.description,
                    });
                });
        }
    };

    _handleShortcutApiKeyChange = (newValue) => {
        // new value should be set to state
        this.setState({
            shortcutApiKey: newValue,
        });
    };

    _handleShortcutApiKeySubmit = () => {
        if (!this.state.shortcutApiKey || !this.state.shortcutApiKey.replace(/\s/g, '').length) {
            this.setState({
                apiSubmitError: 'Please provide a valid API key.',
            });
        } else {
            api.post('/api/integration/set-api-key', {
                name: 'shortcut',
                key: this.state.shortcutApiKey,
            })
                .then((data) => {
                    this._refreshUser();
                    this._getIntegrations();

                    this.setState({
                        shortcutApiKey: '',
                        apiSubmitError: '',
                    });
                })
                .catch((err) => {
                    this.setState({
                        error: err.description,
                    });
                });
        }
    };
}

export default withRouter(Account);
